import {
  params as queryParams,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';

export const packagesModel = {
  packages: queryParams({
    packageId: stringType(),
    storeId: stringType()
  }).arrayOf(shapeType({
    metadata: shapeType({
      image: shapeType({
        url: stringType()
      }),
      name: stringType(),
      title: stringType()
    })
  }))
};
